import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PolicyRulesEditor from "@/components/PolicyRulesEditor";

/** A workspace's own approval rules — self-serve, no Prioris staff needed. */
export default function SettingsPolicy() {
  const [policy, setPolicy] = useState(null);
  const [catalogue, setCatalogue] = useState(null);
  // Bumped after a save, to re-read the ruleset without remounting the tab.
  const [reloads, setReloads] = useState(0);

  useEffect(() => {
    let alive = true;
    Promise.allSettled([api.get("/policy"), api.get("/policy/fields")]).then(
      ([pol, cat]) => {
        if (!alive) return;
        setPolicy(pol.status === "fulfilled" ? pol.value.data : false);
        setCatalogue(cat.status === "fulfilled" ? cat.value.data : null);
      }
    );
    return () => { alive = false; };
  }, [reloads]);

  if (policy === null) {
    return <div className="text-[13px]" style={{ color: "var(--text-muted)" }}>Loading policy…</div>;
  }
  if (policy === false) {
    return <div className="text-[13px]" style={{ color: "var(--text-muted)" }}>Could not load this workspace's policy.</div>;
  }

  return (
    <PolicyRulesEditor
      /* Remounts after a save so the editor restarts from the stored
         ruleset rather than from whatever was half-typed. */
      key={policy?.revision ?? 0}
      basePath="/policy"
      requireReason={false}
      policy={policy}
      catalogue={catalogue}
      onSaved={() => setReloads((n) => n + 1)}
    />
  );
}
